import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopHeaderMobileComponent } from './top-header-mobile.component';


@NgModule({
  declarations: [TopHeaderMobileComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    TopHeaderMobileComponent
  ]
})
export class TopHeaderMobileModule { }
